/**
 * User alias .pgp persistence — user preference state (persisted, NOT
 * document state). Stores the current alias rows plus the pgp version the
 * store has migrated to and the aliases the user deleted (migrations never
 * resurrect a deleted alias — Faz 9.6, OCS migrate_aliases parity).
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AliasEntry {
    /** Uppercased alias token (no `*`). */
    alias: string;
    /** Target command name, `*` prefix stripped, uppercased. */
    command: string;
}

interface AliasPgpState {
    /** Last pgp version this store was migrated through. */
    version: number;
    entries: AliasEntry[];
    /** Aliases the user removed — migrations skip them. */
    removed: string[];
    /** Name of the last imported .pgp file (editor hint only). */
    importFileName: string | null;
    setStore: (input: { entries: AliasEntry[]; removed: string[]; version: number }) => void;
    setImportFileName: (name: string | null) => void;
    clear: () => void;
}

export const useAliasPgpStore = create<AliasPgpState>()(
    persist(
        (set) => ({
            version: 0,
            entries: [],
            removed: [],
            importFileName: null,
            setStore: ({ entries, removed, version }) => set({ entries, removed, version }),
            setImportFileName: (name) => set({ importFileName: name }),
            clear: () => set({ version: 0, entries: [], removed: [], importFileName: null }),
        }),
        { name: 'yap-aliases' }
    )
);
